// AppMain.jsx

export default function AppMain({ children }) {
  return (
    <main className="app-content">
      {children}
    </main>
  );
}